<template>
  <h3
    class="mb-0 flex items-center / text-base font-normal whitespace-nowrap"
    data-testid="deck-tile-slides-header"
    :class="{ selected }"
    @contextmenu.stop.prevent="$emit('contextmenu', $event)"
    @click.exact="$emit('click', $event)"
    @click.shift.exact.capture.stop="$emit('shift-click', slide.id)"
    @click.ctrl.exact.capture.stop="$emit('ctrl-click', slide.id)"
    @click.meta.exact.capture.stop="$emit('ctrl-click', slide.id)"
  >
    <FontAwesomeIcon class="deck-thumbnail-tile__grip cursor-grab" icon="grip-vertical" />
    <InlineEditable
      :value="title"
      class="ml-3 px-0 w-full / focus-within_px-2 hover_px-2 / focus-within_whitespace-normal focus-within_break-words focus-within_bg-black"
      :maxlength="255"
      placeholder="Enter Section Header Title"
      style="max-width: calc(100% - 1.25rem)"
      :disabled="disabled"
      :focus-on-mount="!slide.id"
      theme="dark"
      @click.stop
      @shift-click="$emit('shift-click', slide.id)"
      @ctrl-click="$emit('ctrl-click', slide.id)"
      @focus="$emit('focus:title')"
      @blur="$emit('blur:title')"
      @save="!slide.id && title ? $emit('create-header-slide', { title, order: slide.order }) : $emit('update:title', title)"
      @clear="cancel"
      @cancel="cancel"
      @input="input"
    />
  </h3>
</template>

<script lang="ts" setup>
import type { DeepReadonly, PropType } from 'vue'
import type { Slide } from '@/entities/deck'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  slide: {
    type: Object as PropType<DeepReadonly<Slide>>,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits([
  'click',
  'contextmenu',
  'shift-click',
  'ctrl-click',
  'create-header-slide',
  'cancel-create-header-slide',
  'update:title',
  'focus:title',
  'blur:title',
])

const title = ref(props.slide.title)

watch(
  () => props.slide,
  () => (title.value = props.slide.title),
)

function cancel() {
  title.value = props.slide.title
  emit('cancel-create-header-slide')
}

function input(text: string) {
  title.value = text
}
</script>

<style lang="stylus" scoped>
h3.selected
  @apply rounded-md p-1 border border-white
</style>
